/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Archivev1after2Inputs */

const de__field_archivev1after2 = /** @type {(inputs: _Field_Archivev1after2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Zuteilung nach Datum`)
};

/**

* @param {_Field_Archivev1after2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_archivev1after2 = /** @type {((inputs?: _Field_Archivev1after2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Archivev1after2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_archivev1after2(inputs)
});
export { _field_archivev1after2 as "_field_archiveV1After" }